<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      class="stroke"
      x="1.25"
      y="2.25"
      width="14"
      height="14"
      rx="2"
      fill="none"
      stroke-width="1.5"
    />
    <circle class="knockout" cx="13" cy="4.5" r="5" />
    <circle class="fill" cx="13" cy="4.5" r="3" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "UnreadIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
